import { StringUtils } from "Global/Base/Utils/StringUtils";
import { Localization } from "../../../../../OW.Remoting/Remoting/Localization";
import { createElement, registerCustomElement } from "../../../../UI.ElementarControls/Utils/CustomElementUtils";
import { DropDownMenuCheckboxItem } from "./DropDownMenuItems/DropDownMenuCheckboxItem";
import { IFilterJsonResult, IFilterJsonResultValue, IMultiOperation, IMultiOperationValue, IOperation } from "./FilterInterfaces";
import { FilterItem } from "./FilterItem";
import { logger } from "./logger";

/**
* Třídá obsahující základní filter pro jednu filtrační operaci
*/
export class FilterMultiItem extends FilterItem {
    //private _curValues: IMultiOperationValueList;
    private _curmStruc: IMultiOperation;

    /**
     * Načtení filtru ze struktury
     * @param struct Struktura pro danou operaci
     * @param values Hodnoty pro pole
     */
    public override loadFromStructure(struct: IOperation, values?: { [id: string]: IFilterJsonResultValue }): void {
        this._curStruct = struct;
        logger.log(values);
        //this.fieldContent.appendChild(this.createElementMultiItem(oper, null));

        this._fieldContent.innerHTML = "";
    }

    public async loadStruc(struct: IMultiOperation, values?: { [id: string]: IFilterJsonResultValue }): Promise<void> {
        this._curmStruc = struct;
        if (values) {
            this._isChanged = true;
            for (const grp of struct.groupList) {
                for (const item of grp.operationList) {
                    if (values[item.id]) {
                        const oper = {
                            value: item.value,
                            id: item.id,
                            fieldType: struct.id,
                            displayValue: item.captionHtml,
                        };

                        const chboxitem = this._filterCombo.getItem(oper);
                        if (chboxitem) {
                            chboxitem.isChecked = true;
                        }

                        const multiItem = await this._createElementMultiItem(oper, chboxitem);
                        this._fieldContent.appendChild(multiItem);

                        if (!item.captionHtml) {
                            Localization.getTextPromise(item.lockey)
                                .then((locText) => {
                                    multiItem.querySelector("span").textContent = locText;
                                });
                        }
                    }
                }
            }
        }
    }

    /**
     * Vrátí hodnoty položek
     * @param isForExport Vrácený objekt, nebude mít definované property, které jsou defaultně true. (např. enabled)
     */
    public override getResult(isForExport: boolean = false): IFilterJsonResult {
        const arr: Array<IFilterJsonResultValue> = [];
        const fields = Array.from(this._fieldContent.children) as HTMLElement[];

        for (const ch of fields) {
            //if (this.Parent.Type == FilterTargetType.Column && !this.IsChanged) continue;
            const valueItem: IFilterJsonResultValue = {
                value: ch.getAttribute("data-filter-value"),
                fieldId:  ch.getAttribute("data-filter-id"),
                fieldType: ch.getAttribute("data-filter-type"), //,
                //sign: "or"
            };
            arr.push(valueItem);
        }
        //const isUsed = this.Parent.Type == FilterTargetType.Column ? this.isChanged : this.IsUsed;

        const f: IFilterJsonResult = {
            isMultiItem: true,
            operation: this._curmStruc.id,
            operator: isForExport && this._curSelectedOperation == "or" ? undefined : this._curSelectedOperation,
            values: arr,
            enabled: isForExport && this.isUsed ? undefined : this.isUsed,
            isValid: isForExport ? undefined : true,
        };

        return f;
    }

    private async _createElementMultiItem(oper: IMultiOperationValue, chboxitem: DropDownMenuCheckboxItem): Promise<HTMLElement> {
        // Regex pro formát loc klíče (př.: GUI-468461)
        const captionText = /^GUI-[0-9]+$/.test(oper.displayValue) ? await Localization.getTextPromise(oper.displayValue) : oper.displayValue;

        const oneitem = createElement({
            html: `<span>${StringUtils.stringToHTMLText(captionText)}</span>`,
            classes: "FilterValue",
            attrs: {
                "data-filter-value": oper.value,
                "data-filter-id": oper.id,
                "data-filter-type": oper.fieldType,
            },
        });
        const removeElement = createElement({ classes: "Icon Remove" });
        removeElement.addEventListener("click", (_e: MouseEvent) => {
            if (chboxitem) {
                chboxitem.isChecked = false;
            }
            this._filterCombo.callEvent("ItemUnchecked",
                {
                    operation: oper,
                    element: chboxitem,
                });
        });

        oneitem.appendChild(removeElement);

        return oneitem;
    }

    protected override _constructor(): void {
        super._constructor();

        this.classList.add("FilterMultiItem");
        this._curSelectedOperation = "or";
    }

    // You can also define the other lifecycle methods.
    protected override connectedCallback(): void {
        super.connectedCallback();

        this._filterCombo.setValue("GUI-658184"); // Zvolte hodnotu
        // Kombo pro zmenu typu podmínky
        this._filterCombo.registerEventListener("ItemChecked", async (e: CustomEvent) => {
            //logger.log("ItemSelected", e.detail);
            const oper: IMultiOperationValue = e.detail.operation;
            const el: DropDownMenuCheckboxItem = e.detail.element;

            //if (this.fieldContent.querySelector(`:scope > [data-filter-value='${oper.value}'][data-filter-id='${oper.id}'][data-filter-type='${oper.fieldType}']`) != null) return;
            if (this._fieldContent.querySelector(`[data-filter-value='${oper.value}'][data-filter-id='${oper.id}'][data-filter-type='${oper.fieldType}']`) != null) {
                return;
            }

            this._fieldContent.appendChild(await this._createElementMultiItem(oper, el));
            logger.log(e.detail);
            //this.LoadFromStructure(oper);
            this._isChanged = true;

            this.parent.unsave();
        });

        this._filterCombo.registerEventListener("ItemUnchecked", (e: CustomEvent) => {
            const oper: IMultiOperationValue = e.detail.operation;
            //const el = this.fieldContent.querySelector(`:scope > [data-filter-value='${oper.value}'][data-filter-id='${oper.id}'][data-filter-type='${oper.fieldType}']`);
            const el = this._fieldContent.querySelector(`[data-filter-value='${oper.value}'][data-filter-id='${oper.id}'][data-filter-type='${oper.fieldType}']`);
            if (el != null) {
                el.remove();
            }
            this._isChanged = true;

            this.parent.unsave();
        });
    }
}

registerCustomElement("tsc-FilterMultiItem", FilterMultiItem);
